import { $ } from './../../helpers/query'
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class SpecificationsAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
    this.specSection = document.querySelector('#specifications-section');
    this.specInfo = this.specSection.querySelector('.specifications__info');
    this.specFeatures = $('.specifications-feature', this.specSection);
    this.specAfterClone = this.clonePrevSibling(this.specSection.nextElementSibling);
  }

  // 1. Interract whith Previous section
  // -- 1.1. Interract forward
  onVisitDown() {
    this.hideVideo()
    this.setspecFeaturesDelay(this.specFeatures)
    setTimeout(() => {
      this.specInfo.classList.remove('invisible')
      this.specFeatures.removeClass('specifications-feature--start')
      setTimeout(() => {
        this.specFeatures.css({transitionDelay: ''})
      }, this.ANIM_DUR + 200)
    }, this.ANIM_DUR * 2/3)
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, Math.max(this.TRANS_DUR, (this.ANIM_DUR * 2/3 + (this.ANIM_DUR + 200))))
  }

  // -- 1.2. Interract back
  // 2. Interract whith Next section
  // -- 2.1. Interract forward
  onLeave() {
    window.dispatchEvent(this.transitionStart)
    this.specInfo.classList.add('invisible')
    this.specFeatures.addClass('invisible')
    setTimeout(() => {
      this.specFeatures.removeClass('invisible')
      this.specFeatures.addClass('specifications-feature--start')
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // -- 2.2. Interract back
  onVisitUp() {
    this.hideVideo()
    this.specAfterClone.classList.remove('invisible')
    this.setspecFeaturesDelay(this.specFeatures)
    this.setspecFeaturesDelay($('.specifications-feature', this.specAfterClone))
    setTimeout(() => {
      this.specInfo.classList.remove('invisible')
      this.specFeatures.removeClass('specifications-feature--start')
      this.specAfterClone.querySelector('.specifications__info').classList.remove('invisible')
      $('.specifications-feature', this.specAfterClone).removeClass('specifications-feature--start')
    }, this.ANIM_DUR * 1/3)
    setTimeout(() => {
      this.specAfterClone.classList.add('invisible')
      this.specAfterClone.querySelector('.specifications__info').classList.add('invisible')
      $('.specifications-feature', this.specAfterClone).addClass('specifications-feature--start')
      setTimeout(() => {
        this.specFeatures.css({transitionDelay: ''})
      }, this.ANIM_DUR)
    }, this.ANIM_DUR)
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }

  setspecFeaturesDelay(features) {
    features.each((feature, i) => {
      if (document.documentElement.clientWidth > document.documentElement.clientHeight) {
        if (i > 3) {
          feature.style.transitionDelay = '0.3s';
        }
      } else {
        if (i > 2 && i < 6) {
          feature.style.transitionDelay = '0.3s';
        } else if (i > 5) {
          feature.style.transitionDelay = '0.6s';
        }
      }
    })
  }
}
